import { get } from './utils';

export const getSummaryDetailContactApi = (id: string) =>
  get(`/admin/contacts/${id}/summary`);

export const getContactsBoardApi = (data) => get(`/admin/contacts/board`, data);
